document.addEventListener("DOMContentLoaded", () => {
  initProductSwatches();
});

function initProductSwatches() {
  const sliders = document.querySelectorAll(".psw--slider");

  sliders.forEach(initSlider);
}

function initSlider(slider) {
  const viewport = slider.querySelector(".psw__viewport");

  if (!viewport) return;

  EmblaCarousel(viewport, {
    align: "start",
    containScroll: "trimSnaps",
    dragFree: true,
    loop: false
  });
}